import { AddPageActionPriority, newRelicManager, } from "gather-browser-newrelic-manager/dist/src/public/newRelicManager";
import { getConsoleFn } from "./consoleWrapper";
export var ErrorClass;
(function (ErrorClass) {
    ErrorClass["Unexpected"] = "unexpected";
    ErrorClass["Expected"] = "expected";
    ErrorClass["ErrorThatShouldNeverHappen"] = "errorThatShouldNeverHappen";
})(ErrorClass || (ErrorClass = {}));
export const Logger = {
    log: getConsoleFn("log"),
    warn: getConsoleFn("warn"),
    error: getConsoleFn("error"),
    debug: getConsoleFn("debug"),
    info: getConsoleFn("info"),
    dir: getConsoleFn("dir"),
    unexpectedError: (message, ...data) => {
        Logger.error(message, ...data, { errorClass: ErrorClass.Unexpected });
        newRelicManager?.addPageActionReliably("unexpected-error", { message }, AddPageActionPriority.Low);
    },
    expectedError: (message, ...data) => {
        Logger.error(`${message}`, ...data, { errorClass: ErrorClass.Expected });
    },
    errorThatShouldNeverHappen: (message, ...data) => {
        Logger.error(`[ERROR THAT SHOULD NEVER HAPPEN] ${message}`, ...data, {
            errorClass: ErrorClass.ErrorThatShouldNeverHappen,
        });
        newRelicManager?.addPageActionReliably("error-should-never-happen", { message }, AddPageActionPriority.Urgent);
    },
};
//# sourceMappingURL=Logger.js.map